export default __webpack_public_path__ + "static/media/linkedin_ico.79beda35.svg";